import React from 'react'
import {
  KAMBI_CLIENT_DIV_ID,
  KAMBI_BETSLIP_WRAPPER_DIV_ID,
} from '@core/Areas/KambiClient/constants'

/** Used to ensure that Kambi is hidden on non Kambi routes */
export const useKambiRouteGuard = (): void => {
  React.useEffect(() => {
    document.getElementById(KAMBI_CLIENT_DIV_ID)?.style.setProperty('display', 'block')
    document.getElementById(KAMBI_BETSLIP_WRAPPER_DIV_ID)?.style.setProperty('display', 'block')

    return () => {
      document.getElementById(KAMBI_CLIENT_DIV_ID)?.style.setProperty('display', 'none')
      document.getElementById(KAMBI_BETSLIP_WRAPPER_DIV_ID)?.style.setProperty('display', 'none')
    }
  }, [])
}
